import Immutable             from 'immutable';
import DefaultFlexParameters from '../data/DefaultFlexParameters';

const parameters = (state = Immutable.fromJS(DefaultFlexParameters), action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default parameters;
